// Load progress for the 3D scene, published as a subscribable snapshot.
// Deliberately free of any three.js import so the overlay component and its
// tests never pull the renderer into scope.

let counts = { loaded: 0, failed: 0, total: 0 };
let forcedFinished = false;
let listeners = new Set();
let cached = null;

function derive() {
  const completed = counts.loaded + counts.failed;

  return {
    fraction: counts.total > 0 ? Math.min(1, completed / counts.total) : 0,
    finished: forcedFinished || (counts.total > 0 && completed >= counts.total),
  };
}

// Identity must be stable between changes or useSyncExternalStore re-renders
// without end, so the derived object is cached and discarded only on change.
export function getSnapshot() {
  if (cached === null) {
    cached = derive();
  }

  return cached;
}

export function subscribe(listener) {
  listeners.add(listener);

  return () => listeners.delete(listener);
}

export function setCounts({ loaded = 0, failed = 0, total = 0 } = {}) {
  counts = { loaded, failed, total };

  cached = null;
  listeners.forEach((listener) => listener());
}

export function markFinished() {
  forcedFinished = true;

  cached = null;
  listeners.forEach((listener) => listener());
}

export function resetLoadProgress() {
  counts = { loaded: 0, failed: 0, total: 0 };
  forcedFinished = false;
  listeners = new Set();
  cached = null;
}
